export default "__VITE_ASSET__CqXuzEc4__"